import { Button } from '@crowdfpl/ui-web/button';
import { Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SEO from '@/components/SEO';
import { Footer } from '@/components/shared/layout/footer';
import { GlobalHeader } from '@/components/shared/layout/global-header';
import { MobileBottomNavigation } from '@/components/shared/layout/mobile-bottom-navigation';
import { MobileHeader } from '@/components/shared/layout/mobile-header';
import { useIsMobileNav } from '@/hooks/utils/use-mobile';
import { useAuthModal } from '@/stores/ui';

const NotFound = () => {
  const { showAuthModal } = useAuthModal();
  const isMobileNav = useIsMobileNav();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEO
        title="404 - Page Not Found"
        description="The page you are looking for could not be found. Return to CrowdFPL home page."
      />

      {isMobileNav && <MobileHeader onAuthModalOpen={showAuthModal} />}
      {!isMobileNav && <GlobalHeader onAuthModalOpen={showAuthModal} />}

      <div className={`flex-1 flex items-center justify-center px-4 ${isMobileNav ? 'pb-20' : ''}`}>
        <div className="text-center max-w-2xl mx-auto">
          <h1 className="text-8xl md:text-9xl font-black text-primary mb-6">
            Oops!
          </h1>
          <div className="space-y-4 mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              Page Not Found
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <p className="text-base text-muted-foreground">
              Error 404
            </p>
          </div>
          <Button
            size="lg"
            onClick={() => navigate('/')}
            className="gap-2"
          >
            <Home className="h-5 w-5" />
            Back to Home
          </Button>
        </div>
      </div>

      <Footer hideLinks />
      {isMobileNav && <MobileBottomNavigation />}
    </div>
  );
};

export default NotFound;

